var arslunaLightcase = function($) {
    "use strict";
    function resizeThumbs(selector) {
        $(selector + " .image").each(function(){
            var width, height, image, opacity;
            width = Math.floor($(this).parent().width());
            $(this).css("height",width + "px");
            image = $(this).data("wallpaper");
            $(this).css("background-image","url(" + image + ")");
            $(this).css("background-size","cover");
            $(this).css("background-position","center center");
            $(this).css("background-repeat","no-repeat");
            opacity = $(this).css("opacity");
            if (isNumber(opacity) && opacity < 1) {
                $(this).animate({opacity: 1}, 500);
            }
        });
        $(selector + " .showcase").matchHeight();

    }
    return {
        resizeThumbs : resizeThumbs
    };
}
(jQuery); // END arslunaLightcase
